/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GeneraVisit.vue?vue&type=template&id=479aabd0&scoped=true&"
import script from "./GeneraVisit.vue?vue&type=script&lang=js&"
export * from "./GeneraVisit.vue?vue&type=script&lang=js&"
import style0 from "./GeneraVisit.vue?vue&type=style&index=0&id=479aabd0&lang=less&scoped=true&"
import style1 from "./GeneraVisit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479aabd0",
  null
  
)

export default component.exports